import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_CONSEQUENCE } from "../../code-system/observation-consequence";

export const OBSERVATION_CONSEQUENCE_DISPLAY = composeValueSet({
	name: "OBSERVATION_CONSEQUENCE_DISPLAY",
	description: "Current selection of consequences for displaying observations.",
	system: OBSERVATION_CONSEQUENCE,
	include: getConceptCodes(OBSERVATION_CONSEQUENCE),
});
